import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoParticulierDeclarationSinistre = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 0.75C11.47 0.75 10.98 1.04 10.7 1.51L0.7 19.51C0.13 20.51 0.84 21.75 2 21.75H22C23.16 21.75 23.87 20.51 23.3 19.51L13.3 1.51C13.02 1.04 12.53 0.75 12 0.75ZM12 1.5C12.27 1.5 12.52 1.64 12.67 1.9L22.67 19.9C22.95 20.4 22.59 21 22 21H2C1.41 21 1.05 20.4 1.33 19.9L11.33 1.9C11.48 1.64 11.73 1.5 12 1.5Z",
			fill: "#1E1E1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 7.5H12.75V14.75H11.25V7.5Z",
			fill: "#1E1E1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16C11.31 16 10.75 16.56 10.75 17.25C10.75 17.94 11.31 18.5 12 18.5C12.69 18.5 13.25 17.94 13.25 17.25C13.25 16.56 12.69 16 12 16Z",
			fill: "#2188E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 23.25C2.44 23.25 2.38 23.22 2.34 23.16C2.28 23.07 2.31 22.95 2.4 22.89L4.4 21.56C4.49 21.5 4.61 21.53 4.67 21.62C4.73 21.71 4.7 21.83 4.61 21.89L2.61 23.22C2.58 23.24 2.54 23.25 2.5 23.25ZM21.5 23.25C21.46 23.25 21.42 23.24 21.39 23.22L19.39 21.89C19.3 21.83 19.27 21.71 19.33 21.62C19.39 21.53 19.51 21.5 19.6 21.56L21.6 22.89C21.69 22.95 21.72 23.07 21.66 23.16C21.62 23.22 21.56 23.25 21.5 23.25Z",
			fill: "#2188E5"
		})
	]
});
export default SvgPictoParticulierDeclarationSinistre;
